import type {
  Components,
} from '@vtaits/react-paginator';

import type {
  PaginatorPayload,
} from '../types';

import { Container } from './Container';
import { NextLink } from './NextLink';
import { PreviousLink } from './PreviousLink';

export const components: Partial<Components<PaginatorPayload>> = {
  Container,
  NextLink,
  PreviousLink,
};
